<template>
  <b-container fluid>
    <b-row>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        {{ testSelected ? testSelected.name: null }}
      </b-col>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
          }"
          @click="$emit('back', 'subTest')"
        >
          ย้อนกลับ
        </b-button>
      </b-col>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
            'active': tabSelectedComputed === 'editSubSubTest'
          }"
          @click="$emit('input', 'editSubSubTest')"
        >
          ข้อมูลทั่วไป
        </b-button>
      </b-col>
      <!--      <b-col-->
      <!--        cols="auto"-->
      <!--        :class="{-->
      <!--          'col-left': true,-->
      <!--          'my-auto': true,-->
      <!--        }"-->
      <!--      >-->
      <!--        <b-button-->
      <!--          size="sm"-->
      <!--          :class="{-->
      <!--            'tab-button': true,-->
      <!--            'active': tabSelectedComputed === 'testPrice'-->
      <!--          }"-->
      <!--          @click="$emit('input', 'testPrice')"-->
      <!--        >-->
      <!--          ราคา-->
      <!--        </b-button>-->
      <!--      </b-col>-->
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
            'active': tabSelectedComputed === 'subSubTestRefRange'
          }"
          @click="$emit('input', 'subSubTestRefRange')"
        >
          Ref Range
        </b-button>
      </b-col>
    </b-row>
    <template v-if="tabSelectedComputed === 'subSubTestRefRange' || tabSelectedComputed === 'refRangeMultiCreate'">
      <b-row class="pt-3 mt-3 sub-panel">
        <b-col cols="auto">
          <b-button
            variant="success"
            size="sm"
            @click="updateRefRangeHandler"
          >
            บันทึก
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'refRangeMultiCreate'
            }"
            @click="$emit('input', 'refRangeMultiCreate')"
          >
            เพิ่มค่า Ref Range
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
  export default {
    name: "SubSubTestLevelTitle",
    props: {
      value: {
        type: String,
        default: 'editTest'
      },
      testSelected: {
        type: Object,
        default: () => null,
      }
    },
    computed: {
      tabSelectedComputed: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
    },
    methods: {
      async updateRefRangeHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('update-ref-range', password)
        } else {
          return
        }

      }
    }
  }
</script>

<style lang="scss" scoped>
  .action-panel {
    opacity: 0;
    &.visible {
      opacity: 100%;
    }
  }

  .tab-button {
    &.active {
      background: #2E83D9 !important;
      color: white;
    }
  }

  .test-sequence-panel {
    border-top: 1px solid black;
  }
</style>